import React, { Component } from "react"
import ReactDOM from "react-dom"
import {
  Switch,
  Route,
  HashRouter as Router,
  withRouter
} from "react-router-dom"

//IMPORT REDUX
import { connect } from "react-redux"

//IMPORT REACT COMPONENTS
import ParametreEntete from "./Entete/ParametreDevisFacturesComponent"
import ParametreFooter from "./PiedDePage/ParametrePiedDePageComponent"
import ParametreDevis from "./DocumentDevisFacture/ParametreDocumentDevisFactureComponent"
import ParametreEntreprise from "./MonEntreprise/ParametreMonEntrepriseComponent"
import MenuEntete from "./MenuEntete"
const mapStateToProps = state => {
  return { token: state }
}

class ConnectedParametresRouter extends React.Component {
  constructor(props) {
    console.log("props parametre", props)
    super(props)
  }
  render() {
    const { goBack } = this.props.history.goBack
    return (
      <main>
        <MenuEntete goBack={goBack} />

        <Router>
          <Switch>
            <Route path="/mtpro/parametre/footer" component={ParametreFooter} />
            <Route
              path="/mtpro/parametre/entreprise"
              component={ParametreEntreprise}
            />
            <Route
              path="/mtpro/parametre/devisfacture"
              component={ParametreDevis}
            />
            <Route path="/mtpro/parametre" component={ParametreEntete} />
          </Switch>
        </Router>
      </main>
    )
  }
}

const ParametresRouter = connect(mapStateToProps)(ConnectedParametresRouter)
export default ParametresRouter



// WEBPACK FOOTER //
// ./src/components/Pro/Parametres/ParametresRouter.js